module.exports = __webpack_public_path__ + "img/rating_1.75bd0db7.png";